import React from "react";
import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css/pagination";

import SwiperArrows from "../Slider/SliderArrows";

const FeaturedSlider = ({ title, slidesJson }) => {
	const slides = JSON.parse(slidesJson);

	return (
		<div className="featured-slider-block__outer-container">
			<div className="featured-slider-block__container">
				<div className="featured-slider-block__container__header">
					{title && <h2>{title}</h2>}
					<SwiperArrows />
				</div>
				<Swiper
					modules={[A11y, Navigation, Pagination, Autoplay]}
					navigation={{
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					}}
					pagination={{ clickable: true, el: ".swiper-pagination" }}
					slidesPerView={1}
					autoplay={{
						delay: 4000,
						disableOnInteraction: true,
					}}
					loop={true}
				>
					{slides.map((slide, index) => {
						return (
							<SwiperSlide key={index}>
								<li key={index} className="featured-slide">
									<div className="featured-slide__image-container">
										<img src={slide.image.url} alt={slide.title} />
									</div>
									<div className="featured-slide__content-container">
										<h3>{slide.title}</h3>
										<p>{slide.description}</p>
										{slide.button && slide.button.url && (
											<a
												className="button"
												href={slide.button.url}
												target={slide.button.target ? slide.button.target : ""}
											>
												{slide.button.title}
											</a>
										)}
									</div>
								</li>
							</SwiperSlide>
						);
					})}
				</Swiper>
			</div>
			<div className="swiper-pagination" />
		</div>
	);
};

FeaturedSlider.propTypes = {
	slidesJson: PropTypes.string,
	title: PropTypes.string,
};

export default FeaturedSlider;
